import { useQuery } from '@tanstack/react-query'
import { saveSubSettings, subSettingsQuery } from '../api/devices'
import { FormRow, HalfField } from '../ui/FormGrid'
import { toast } from '../ui/notify'
import { Spinner } from '../ui/Spinner'
import type { ScreenProps } from './screens'

/**
 * Fila Sub-category - inventoree/devices/others/deviceSubSettings.php.
 * Salvarea merge pe GET /api/v2/devices/{id}/sub-settings?subCategory=.
 *
 * Un singur camp, dar tot pe grila comuna (`ui/FormGrid.tsx`): eticheta
 * deasupra, campul pe coloana din stanga, ca in celelalte file ale fisei. Asa
 * ramane pe aceleasi doua margini de coloana ca Settings sau Properties, si nu
 * mai sare de la o fila la alta.
 */

export function DeviceSubSettings({ id }: ScreenProps) {
  const { data, error } = useQuery(subSettingsQuery(id))
  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {error.message}
      </div>
    )
  }
  if (!data) return <Spinner />
  if (data.empty) {
    return (
      <div className="col-md-12">
        <div className="alert alert-danger">No settings for this device.</div>
      </div>
    )
  }
  return (
    <div className="device-sub-settings">
      <header className="panel-heading sm" data-color="theme-inverse">
        <h4>Device sub-category</h4>
      </header>
      <div className="panel-body">
        <FormRow>
          <HalfField label="Device sub-type" htmlFor="device_sub_category">
            <select
              className="form-control"
              name="device_sub_category"
              id="device_sub_category"
              defaultValue={data.subCategory}
              onChange={(event) => {
                /* Select... (0) se trimite si el, ca in deviceSubSettings.php: asa se scoate sub-tipul. */
                saveSubSettings(id, Number(event.currentTarget.value))
                  .then((saved) => {
                    if (saved.status === 'success') toast(saved.message, 'Success', 'success')
                    else toast(saved.message, 'Error', 'error')
                  })
                  .catch((err) =>
                    toast(
                      err instanceof Error ? err.message : 'A error occured, please contact admin!',
                      'Error',
                      'error',
                    ),
                  )
              }}
            >
              <option value="0">Select...</option>
              {data.options.map((o) => (
                <option key={o.id} value={o.id}>
                  {o.name}
                </option>
              ))}
            </select>
          </HalfField>
        </FormRow>
      </div>
    </div>
  )
}
